import React from 'react';
import {
    ListItem,
    ListItemAvatar,
    Avatar,
    Badge,
    Typography,
    Box,
    Chip,
    Divider
} from '@mui/material';

const ChatItem = React.memo(({
                                 chat,
                                 isSelected,
                                 onSelect,
                                 hasNewMessage,
                                 formatTime,
                                 getStatusColor
                             }) => {
    const handleClick = React.useCallback(() => {
        onSelect(chat);
    }, [chat, onSelect]);

    return (
        <React.Fragment>
            <ListItem
                button
                selected={isSelected}
                onClick={handleClick}
                sx={{
                    animation: hasNewMessage ? 'pulse 1s infinite' : 'none',
                    '@keyframes pulse': {
                        '0%': { backgroundColor: 'rgba(25, 118, 210, 0.1)' },
                        '50%': { backgroundColor: 'rgba(25, 118, 210, 0.2)' },
                        '100%': { backgroundColor: 'rgba(25, 118, 210, 0.1)' }
                    }
                }}
            >
                <ListItemAvatar>
                    <Badge
                        badgeContent={chat.unread_count}
                        color="error"
                        invisible={chat.unread_count === 0}
                    >
                        <Avatar>
                            {chat.contact?.name?.charAt(0)?.toUpperCase() || '?'}
                        </Avatar>
                    </Badge>
                </ListItemAvatar>

                {/* Заменяем ListItemText на обычный Box */}
                <Box sx={{ flexGrow: 1, minWidth: 0, ml: 2 }}>
                    {/* Primary content */}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="subtitle2" noWrap sx={{ flexGrow: 1 }}>
                            {(chat.contact?.phone || 'No phone') + (chat.contact?.name ? ` (${chat.contact.name})` : '')}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {formatTime(chat.last_message_at)}
                        </Typography>
                    </Box>

                    {/* Secondary content */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {chat.account?.active_instance && (
                            <Chip
                                size="small"
                                label={chat.account_phone}
                                color={getStatusColor(chat.account.active_instance.status)}
                                variant="filled"
                                sx={{ height: 18, fontSize: '0.7rem' }}
                            />
                        )}
                        <Typography variant="caption" color="text.secondary" noWrap>
                            {chat.account?.active_instance?.alias ? ` (${chat.account.active_instance.alias})` : ''}
                        </Typography>
                    </Box>
                </Box>
            </ListItem>
            <Divider />
        </React.Fragment>
    );
});

ChatItem.displayName = 'ChatItem';

export default ChatItem;